import {
    StationConfigurationStatus,
    StationEvseAvailabilityStatus,
    StationEvseStatus,
    StationStatus,
} from "./Station";

export enum WssStationEventTypes {
    STATION_STATUS = "station_status",
    EVSE_STATUS = "evse_status",
    EVSE_NOT_FOUND = "evse_not_found",
    STATION_CONFIG_CHANGE = "station_config_change",
    STATION_CONFIG_REFRESH = "station_config_refresh",
    STATION_RESET = "station_reset",
    STATION_AVAILABILITY = "station_availability",
    EVSE_AVAILABILITY = "evse_availability",
    UNLOCK_CONNECTOR = "unlock_connector",
}

export interface WssStationPayload {
    event: WssStationEventTypes;
    stationId?: string;
    stationIdentifier?: string;
    locationName?: string;
    stationEvseId?: string;
    connectorId?: number;
    status?:
        | StationStatus
        | StationEvseStatus
        | StationConfigurationStatus
        | StationEvseAvailabilityStatus;
    key?: string;
    newValue?: string | null;
    success?: boolean;
    companyId: string;
}
